import { CleverOperations } from "./CleverOperations";

export default CleverOperations;
